// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --orange: #faa718;
}

.src-js-components-tabs-styles-module__nav--ZDJZH {
  list-style: none;
  list-style-type: none;
  list-style-position: initial;
  list-style-image: initial;
  padding-bottom: 5px;
}

.src-js-components-tabs-styles-module__navTabs--G5Hdu {
  border-radius: 4px;
  margin-right: 3px;
}

.src-js-components-tabs-styles-module__navLink--fAOgP {
  color: white;
  background-color: transparent;
  float: left;
  padding: 10px 15px;
  text-decoration: none;
}

.src-js-components-tabs-styles-module__navLinkInverted--xgGCk {
  color: black;
  background-color: transparent;
  float: left;
  padding: 10px 15px;
}

.src-js-components-tabs-styles-module__navTabs--G5Hdu:hover,
.src-js-components-tabs-styles-module__navTabs--G5Hdu:focus {
  background-color: var(--orange) !important;
  color: white;
}

.src-js-components-tabs-styles-module__active--uww8Q,
.src-js-components-tabs-styles-module__active--uww8Q:hover,
.src-js-components-tabs-styles-module__active--uww8Q:active,
.src-js-components-tabs-styles-module__active--uww8Q:focus {
  background-color: var(--orange) !important;
  color: white;
  cursor: default;
}

.src-js-components-tabs-styles-module__disabled--h5PZP {
  color: #999999;
  cursor: default;
}

.src-js-components-tabs-styles-module__disabled--h5PZP:hover {
  background-color: #071c35 !important;
  cursor: default;
}

.src-js-components-tabs-styles-module__tabPane--Qcf1X {
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/tabs/styles.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;;;;EAIE,0CAA0C;EAC1C,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[":root {\n  --orange: #faa718;\n}\n\n.nav {\n  list-style: none;\n  list-style-type: none;\n  list-style-position: initial;\n  list-style-image: initial;\n  padding-bottom: 5px;\n}\n\n.navTabs {\n  border-radius: 4px;\n  margin-right: 3px;\n}\n\n.navLink {\n  color: white;\n  background-color: transparent;\n  float: left;\n  padding: 10px 15px;\n  text-decoration: none;\n}\n\n.navLinkInverted {\n  color: black;\n  background-color: transparent;\n  float: left;\n  padding: 10px 15px;\n}\n\n.navTabs:hover,\n.navTabs:focus {\n  background-color: var(--orange) !important;\n  color: white;\n}\n\n.active,\n.active:hover,\n.active:active,\n.active:focus {\n  background-color: var(--orange) !important;\n  color: white;\n  cursor: default;\n}\n\n.disabled {\n  color: #999999;\n  cursor: default;\n}\n\n.disabled:hover {\n  background-color: #071c35 !important;\n  cursor: default;\n}\n\n.tabPane {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `src-js-components-tabs-styles-module__nav--ZDJZH`,
	"navTabs": `src-js-components-tabs-styles-module__navTabs--G5Hdu`,
	"navLink": `src-js-components-tabs-styles-module__navLink--fAOgP`,
	"navLinkInverted": `src-js-components-tabs-styles-module__navLinkInverted--xgGCk`,
	"active": `src-js-components-tabs-styles-module__active--uww8Q`,
	"disabled": `src-js-components-tabs-styles-module__disabled--h5PZP`,
	"tabPane": `src-js-components-tabs-styles-module__tabPane--Qcf1X`
};
export default ___CSS_LOADER_EXPORT___;
